import { createTheme } from '@mui/material/styles';

const headingFont = '"Noto Sans", sans-serif';
const bodyFont = '"Noto Sans", sans-serif';

export const buildMuiTheme = (mode: 'light' | 'dark') =>
  createTheme({
    palette: {
      mode,
      primary: {
        main: '#2890F7',
        dark: '#2188ED',
        contrastText: '#ffffff'
      },
      secondary: {
        main: '#059669',
        dark: '#07D192',
        contrastText: '#ffffff'
      },
      background: {
        default: mode === 'dark' ? '#0b1220' : '#f8fafc',
        paper: mode === 'dark' ? '#0f172a' : '#ffffff'
      }
    },
    typography: {
      fontFamily: bodyFont,
      h1: { fontFamily: headingFont },
      h2: { fontFamily: headingFont },
      h3: { fontFamily: headingFont },
      h4: { fontFamily: headingFont },
      h5: { fontFamily: headingFont },
      h6: { fontFamily: headingFont },
      subtitle1: { fontFamily: bodyFont },
      subtitle2: { fontFamily: bodyFont },
      body1: { fontFamily: bodyFont },
      body2: { fontFamily: bodyFont },
      button: {
        fontFamily: bodyFont,
        textTransform: 'none',
        fontWeight: 600
      }
    },
    shape: {
      borderRadius: 12
    },
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            textTransform: 'none'
          }
        }
      }
    }
  });
